export default function createSelectedEvent(eventKey) {
  let selectionPrevented = false;

  return {
    eventKey,

    preventSelection() {
      selectionPrevented = true;
    },

    isSelectionPrevented() {
      return selectionPrevented;
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/utils/createSelectedEvent.js
 **/